module.exports = __webpack_public_path__ + "static/media/loc3_img11.af1781cd.jpg";